export const aboutNestedRoutes = [
  {
    id: 1,
    link: "/about/overview",
    label: "Overview",
  },
  {
    id: 2,
    link: "/about/strategy",
    label: "Strategy",
  },
  {
    id: 3,
    link: "/about/business-model",
    label: "Business Model",
  },
  {
    id: 4,
    link: "/about/leadership-team",
    label: "Leadership Team",
  },
  {
    id: 5,
    link: "/about/management-team",
    label: "Management Team",
  },
  {
    id: 6,
    link: "/about/our-value-and-approach",
    label: "Our value and approach",
  },
  {
    id: 7,
    link: "/about/our-projects",
    label: "Our Projects",
  },
  {
    id: 8,
    link: "/about/governance-&-policies",
    label: "Governance & Policies",
  },

  {
    id: 9,
    link: "/about/presentation-&-reports",
    label: "Presentation & Reports",
  },
];
